import React from 'react';

function ContentHeadline({ headline, style })
{
  switch (style.name)
  {
    case "Headline H2 Blue":
      return (
        <h2 className="text-blue text-3xl font-semibold mb-2.5">{headline}</h2>
      )
    case "Headline H2 Blue Center":
      return (
        <h2 className="text-blue text-3xl font-bold mb-2.5 text-center">{headline}</h2>
      )
    case "Headline H4 blue":
      return (
        <h2 className="text-blue text-3xl font-semibold mb-2.5 ">{headline}</h2>
      )
    case "Headline XL with hor line":
      return (
        <div className="flex justify-center items-center py-16">
          <div className="bg-blue h-px flex-grow" />
          <h2 className="text-blue px-8 uppercase text-3xl font-bold">{headline}</h2>
          <div className="bg-blue h-px flex-grow" />
        </div>
      );
    default:
      return null
  }


}

export default ContentHeadline;